import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { WorkShiftType } from "./types";

export const WorkShiftTypeOptions = [
  {
    label: i18n.t("fixedShift"),
    subLabel: i18n.t("fixedShiftDescription"),
    value: WorkShiftType.Fixed,
  },
  {
    label: i18n.t("flexibleShifts"),
    subLabel: i18n.t("flexibleShiftsDescription"),
    value: WorkShiftType.Dynamic,
  },
];

export const WorkShiftTypeMap = getMapObjectFromArray(WorkShiftTypeOptions);
